<p id="version" class="footer">
    {{'©' + copyrightYear + ' Foundations in Learning'}}<br/>
    {{'Version: ' + versionNumber}}
  </p>
  